import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

export type ToggleProps = {
  label: string;
  checked?: boolean;
  labelClassName?: string;
  activeToggleClassName?: string;
  onChange?: (checked: boolean) => void;
};

export const Toggle = ({ label, checked = false, onChange, labelClassName, activeToggleClassName }: ToggleProps) => {
  const [isChecked, setIsChecked] = useState(checked);

  const handleToggle = () => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    onChange?.(newValue);
  };

  return (
    <div className="flex items-center gap-7">
      <button
        type="button"
        role="switch"
        aria-checked={isChecked}
        onClick={handleToggle}
        className={twMerge(
          'relative h-24 w-48 rounded-full transition-colors duration-200 ease-in-out',
          'focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-offset-2',
          isChecked ? (activeToggleClassName ? activeToggleClassName : 'bg-primary-400') : 'bg-grey-100',
        )}
      >
        <span
          className={twMerge(
            'absolute left-2 top-2 h-20 w-20 transform rounded-full bg-white transition-transform duration-200 ease-in-out',
            isChecked && 'translate-x-24',
          )}
        />
      </button>
      {label && (
        <span
          className={twMerge('font-basel-grotesk text-sm font-medium leading-normal text-grey-500', labelClassName)}
        >
          {label}
        </span>
      )}
    </div>
  );
};

export default Toggle;
